module.exports = __webpack_public_path__ + "img/app_in_white_ja.d8ae101c.png";